"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PayoutRemittance = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.PayoutRemittance = typebox_1.Type.Object({
    vendorName: typebox_1.Type.Optional(typebox_1.Type.String()),
    totalAmount: typebox_1.Type.String(),
    paymentMethod: typebox_1.Type.String(),
    expectedDelivery: typebox_1.Type.Optional(typebox_1.Type.String()),
    invoiceCount: typebox_1.Type.String(),
    transactionId: typebox_1.Type.String(),
});
//# sourceMappingURL=payout-remittance.js.map